// Generated by CoffeeScript 2.7.0
var TransferAssignmentSetting;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import UserSearch from 'trunks/vue/admin/components/search/user.js';

import TransferSettingMixin from 'trunks/vue/share/mixins/yet_another_workflow/assignment_settings/transfer.js';

export default TransferAssignmentSetting = {
  mixins: [TransferSettingMixin],
  components: {
    'user-search': UserSearch
  },
  template: `<div class="form-field inline" :class="{ 'has-error': !valid }">
  <div class="form-field-head">
    <div class="form-field-title">转交给</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input">
      <user-search ref='users'
                   placeholder='请输入'
                   :remote='remote_users_url'
                   @valueChanged='updateUsers'
                   popoverPosition='bottom'
                   :selectedUserIds='user_ids' />
    </div>
    <div class="message" v-if='!valid'>转交人不能为空</div>
  </div>
</div>`,
  created: function() {
    return this.remote_users_url = Skylark.Helpers.UrlHelper.namespaceUrlFor('/users/query', {
      exclude_self: true
    });
  },
  methods: {
    updateUsers: function(vm) {
      // //FIXME: user-search multiple false
      if (vm.selectedItems.length <= 1) {
        this.user_ids = _.pluck(vm.selectedItems, "id");
      } else {
        vm.unselect(_.first(vm.selectedItems));
        this.user_ids = _.pluck([_.last(vm.selectedItems)], "id");
      }
      if (this.valid) {
        return;
      }
      return this.markTransferValid();
    },
    onTransferInvalid: function() {
      newAlertify('提交失败', {
        type: 'error',
        description: '请选择转交人'
      });
    }
  }
};
